import { render, staticRenderFns } from "./MenuPantallaStore.vue?vue&type=template&id=c5894ef2&scoped=true"
import script from "./MenuPantallaStore.vue?vue&type=script&lang=js"
export * from "./MenuPantallaStore.vue?vue&type=script&lang=js"
import style0 from "./MenuPantallaStore.vue?vue&type=style&index=0&id=c5894ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5894ef2",
  null
  
)

export default component.exports